import { ArrowLeft, ExternalLink } from "lucide-react"
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux"
import { getHistory } from "../../redux/slices/rangoSlice";
import TransactionHistory from "../shared/TransactionHistory";

const RangoTransactionHistory = ({ handleClick }) => {
  const dispatch = useDispatch();
  const rangoHistory = useSelector((state) => state.rango.history);
  const [selectedTransaction, setSelectedTransaction] = useState(null);
  const rangoLoading = useSelector((state) => state.rango.loading);
  const mode = useSelector((state) => state.mode.mode); // 'public' or 'private'

  useEffect(() => {
    dispatch(getHistory(mode === 'private' ? 'private' : 'public'));
  }, [dispatch, mode]);

  const handleTransactionClick = (tx) => {
    setSelectedTransaction(tx === selectedTransaction ? null : tx);
  };

  return (
    <div>
      <div className="row">
        <div className={selectedTransaction ? "col-lg-8" : "col-12"}>
          <TransactionHistory
            transactions={rangoHistory}
            loading={rangoLoading}
            onTransactionClick={handleTransactionClick}
          />
        </div>

        {selectedTransaction && (
          <div className="col-lg-4 mt-4 mt-lg-0">
            <div className="card shadow-sm border-0 position-sticky top-4 overflow-hidden" style={{ borderRadius: "18px" }}>
              <div className="card-header bg-white py-3 border-bottom d-flex justify-content-between align-items-center">
                <h6 className="mb-0 fw-bold">Swap Details</h6>
                <button
                  className="btn-close"
                  style={{ fontSize: '0.8rem', color: 'inherit' }}
                  onClick={() => setSelectedTransaction(null)}
                ></button>
              </div>
              <div className="card-body">
                <div className="mb-4">
                  {selectedTransaction.swaps?.map((swap, index) => (
                    <div key={index} className="mb-4">
                      <div className="d-flex align-items-center justify-content-between mb-2">
                        <div className="d-flex align-items-center gap-2">
                          <img src={swap.from.logo} alt="" width="24" height="24" className="rounded-full" />
                          <span className="fw-bold">{parseFloat(swap.fromAmount).toFixed(4)} {swap.from.symbol}</span>
                        </div>
                        <div className="text-muted small">[{swap.from.blockchain}]</div>
                      </div>

                      <div className="d-flex align-items-center gap-3 my-2 text-primary">
                        <div className="flex-grow-1 border-top border-primary border-dashed"></div>
                        <div className="d-flex align-items-center gap-2 small fw-bold">
                          <img src={swap.swapperLogo} alt="" width="16" height="16" />
                          {swap.swapperId}
                        </div>
                        <div className="flex-grow-1 border-top border-primary border-dashed"></div>
                      </div>

                      <div className="d-flex align-items-center justify-content-between mt-2">
                        <div className="d-flex align-items-center gap-2">
                          <img src={swap.to.logo} alt="" width="24" height="24" className="rounded-full" />
                          <span className="fw-bold">{parseFloat(swap.toAmount).toFixed(4)} {swap.to.symbol}</span>
                        </div>
                        <div className="text-muted small">[{swap.to.blockchain}]</div>
                      </div>
                    </div>
                  ))}
                </div>

                <div className="border-top pt-4">
                  <div className="d-flex justify-content-between">
                    <span className="text-muted">Status:</span>
                    <span className={`badge ${selectedTransaction.status === 'completed' ? 'bg-success' : 'bg-warning'}`}>
                      {selectedTransaction.status === 'completed' ? 'Success' : selectedTransaction.status}
                    </span>
                  </div>
                </div>
                <div className="border-top pt-4 mt-4">
                  <div className="mb-3">
                    <span className="text-muted d-block mb-1 text-sm">Request ID:</span>
                    <div className="d-flex align-items-center gap-2">
                      <code className="bg-light p-2 rounded flex-grow-1 text-truncate text-dark">
                        {selectedTransaction.requestId}
                      </code>
                      <button
                        className="p-2 border rounded"
                        onClick={() => window.open(`https://explorer.rango.exchange/swap/${selectedTransaction.requestId}`, '_blank')}
                      >
                        <ExternalLink size={18} />
                      </button>
                    </div>
                  </div>
                  {selectedTransaction.error && (
                    <div className="alert alert-danger py-2 small mb-0">
                      <strong>Error:</strong> {selectedTransaction.error}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  )
}

export default RangoTransactionHistory
